import { nanoid } from 'nanoid'
const getSortable = () => import('sortablejs')

/* @ngInject */
function BriefingDetailsController ($scope, $rootScope, $q, $state, $stateParams, $timeout, $translate, $location, BriefingService, BusinessDataService, BoardsService, MessageService, ToastService, AttachmentService, TrixEditorService, UserService, AdminService, GroupService, UdsModalService, SegmentService, UploadService, NewAssetService, BackendErrorParserService, ConditionalService, ConfirmationModalService, CONSTANTS, Utils) {
  const getNewGroupDialogController = () => $q.when(import('../../dialogs/new-group/new-group-dialog.controller'))
  const getUpgradeCompanyPlanDialogController = () => import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')
  const getAttachInsideTheModuleModalController = () => $q.when(import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller'))
  const getWarningSaveDiscardDialogController = () => $q.when(import('../../../core/dialogs/warning-save-discard/warning-save-discard-dialog.controller'))

  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId
  $scope.companyFeatures = {
    briefingSegmentation: false,
    automaticScore: false,
    placeholderTexts: {
      access: false,
      data: {}
    },
    boardStepAdvancedResources: {
      access: false,
      data: {}
    }
  }
  $scope.segmentationOption = 'USERS'
  $scope.allUsersChecked = true
  $scope.attachedAllFiles = true
  $scope.isThereBriefingTasks = false
  $scope.hasActiveTasksFromUsers = false
  $scope.businesDataOptions = []
  $scope.toggleOptions = []
  $scope.uploadedFiles = []
  $scope.aUsers = []

  $scope.disablePublicationConfigs = false

  let planName = ''
  let addingNewField = false
  let sortingField = false
  let deletingField = false
  let duplicatingField = false
  let showInvalidFields = false

  let usersIndex = 0
  const usersTop = 100

  const flags = {
    wasSaved: false,
    wasUpdated: false
  }

  /**
   * State provider data:
   * $scope.id?
   */
  const api = {
    getNewGroupDialogController,
    getUpgradeCompanyPlanDialogController,
    getWarningSaveDiscardDialogController,
    _initializeMultiSelectFields,
    _getBriefingModel,
    _getFieldsTypes,
    _reloadDropdownFields,
    _duplicateDropdownOptions,
    _getBusinessDataFields,
    _getCompanyBoards,
    _calculateBriefingScore,
    _getUsers,
    _getGroups,
    _handleSuccessGetUsers,
    _handleGetGroupsResponse,
    _getGroupValues,
    _getUserValues,
    _addDropdownValue,
    _onCompleteCarrosselUpload,
    _setWorkingDaysValue,
    _openUpgradeCompanyPlanDialog,
    _handleBriefingSegmentation,
    _avaliableBusinessDataField,
    _getCompanyFeatures,
    _handlePricingCheckboxes,
    _validateIsArchivedAttr,
    _setDefaultBriefing,
    _validateConditionalFields,
    _minimizeAllFields,
    _initializeSortableOrdenation,
    _initializeSortableFields,
    _onFieldSort,
    _handleFieldOrder,
    _orderFieldOnSameSection,
    _orderFieldDifferentSection,
    _verifyInconsistentAction,
    _removeDuplicatedValues,
    _openWarningSaveDiscardDialog,
    _fillInputsWithCampaignInfo,
    _checkJQueryReadiness,
    _debouncedDropdownReload,
    _forceRestoreDropdownOptions,
    _reattachFieldClickHandlers,
    _checkBriefingActiveTasks
  }
  this.getApi = () => api

  $scope.maxScore = 100
  $scope.type = $state.current.data.type
  $scope.currentCampaignId = $stateParams.campaignId

  $scope.title = $scope.type === 'WORKFLOW' ? $translate.instant('workflow.briefingModels') : $translate.instant('auditBriefing.auditModel')
  $scope.subtitle = $scope.type === 'WORKFLOW' ? $translate.instant('workflow.briefingsSubtitle') + '. ' + $translate.instant('helpMsg.message') : $translate.instant('auditBriefing.auditModelSubtitle')

  $scope.initialLoad = true
  $scope.loading = true
  $scope.attachments = [] // array de uuid

  $scope.jQueryComponentsReady = false
  const jQueryReadiness = {
    dropdowns: false,
    sortables: false,
    popups: false
  }

  let dropdownReloadTimeout = null
  function _debouncedDropdownReload () {
    if (dropdownReloadTimeout) {
      $timeout.cancel(dropdownReloadTimeout)
    }

    dropdownReloadTimeout = $timeout(() => {
      api._reloadDropdownFields()
    }, 200)
  }

  function _checkJQueryReadiness () {
    const allReady = Object.values(jQueryReadiness).every(ready => ready === true)
    if (allReady && !$scope.jQueryComponentsReady) {
      $scope.jQueryComponentsReady = true

      if (!$scope.$$phase) {
        $scope.$apply()
      }
    }
  }

  const deregisterSegmentationOptionWatcher = $scope.$watch('segmentationOption', (newVal) => {
    if (newVal === 'GROUPS') {
      $scope.briefing.users = []
      return
    }

    $('.briefing-groups-dropdown').dropdown('clear')
  })

  $scope.$on('$destroy', () => {
    deregisterSegmentationOptionWatcher()
    $(document).off('click', api._minimizeAllFields)

    if ($scope.briefing?.sections) {
      $scope.briefing.sections.forEach(section => {
        if (section.sortableObj?.destroy) {
          section.sortableObj.destroy()
          section.sortableObj = null
        }
      })
    }
  })

  $scope.sortableOptions = {
    stop: api._debouncedDropdownReload,
    axis: 'y',
    'ui-floating': true
  }
  $scope.briefing = {
    id: null,
    assignees: [],
    briefingType: $scope.type,
    name: '',
    description: '',
    automaticScore: false,
    totalScore: 0,
    leftScore: 100,
    leftScoreMsg: $translate.instant('ScoreToBeFilled', { leftScore: 100 }),
    fields: [],
    isPrivate: false,
    users: [],
    groups: [],
    campaignId: null,
    consultantApproval: false
  }

  function activate () {
    $scope.currentModule = $location.path().includes('audit') ? 'checklists' : 'briefings'
    $rootScope.isSecondLevelSidebarExpanded = false

    api._setDefaultBriefing()
    api._getCompanyFeatures()
      .then(() => {
        $timeout(() => {
          $('.input-data-field').popup({})
          $(document).on('click', api._minimizeAllFields)

          jQueryReadiness.popups = true
          api._checkJQueryReadiness()
        }, 1500, false)

        const promises = [
          api._getFieldsTypes($scope.type),
          api._getBusinessDataFields()
        ]

        if ($scope.type === 'WORKFLOW') {
          promises.push(api._getUsers(), api._getCompanyBoards())

          if (!$rootScope.isUser()) {
            promises.push(api._getGroups())
          }

          UserService.getAdministratorsAndDesigners().then(response => { $scope.users = response.rows })
        }

        Promise.all(promises).then(() => api._getBriefingModel($stateParams.id))
      })
  }

  activate()

  function _getCompanyFeatures () {
    return $q.all([
      $rootScope.getCompanyFeaturesAndAddons(),
      $rootScope.getCompanyFeatures()
    ]).then(([featuresAndAddons, companyFeatures]) => {
      planName = featuresAndAddons.name
      const { features } = featuresAndAddons
      $scope.companyFeatures = {
        placeholderTexts: {
          access: !!features['ARTS.EDITOR_AUTOMATIC_FIELDS'],
          data: {
            featureName: $translate.instant('billingFeatures.artsEditorAutomaticFields'),
            featureSlug: 'ARTS.EDITOR_AUTOMATIC_FIELDS'
          }
        },
        automaticScore: !!features['CHECKLIST.AUTOMATIC_SCORE'],
        briefingSegmentation: !!features['WORKFLOW.SEGMENTED_BRIEFINGS'],
        boardStepAdvancedResources: {
          access: !!features['WORKFLOW.BOARD_STEP_ADVANCED_RESOURCES'],
          data: {
            featureName: $translate.instant('billingFeatures.boardStepAdvancedResources'),
            featureSlug: 'WORKFLOW.BOARD_STEP_ADVANCED_RESOURCES'
          }
        }
      }
      api._handleBriefingSegmentation($scope.companyFeatures.briefingSegmentation)
      api._handlePricingCheckboxes()
    })
  }

  function _openWarningSaveDiscardDialog () {
    api.getWarningSaveDiscardDialogController().then(({ WarningSaveDiscardDialogController }) => {
      const warningSaveDiscardDialog = UdsModalService.createModal({
        controller: WarningSaveDiscardDialogController,
        modalName: 'warningSaveDiscard',
        data: {
          closeModal: () => {
            $scope.backToBriefings()
          }
        }
      })

      warningSaveDiscardDialog.open()
    })
  }

  $scope.handleAutomaticScorePricing = function () {
    if (!$scope.companyFeatures.automaticScore) {
      api._openUpgradeCompanyPlanDialog({
        name: $translate.instant('billingFeatures.automaticScore'),
        slug: 'CHECKLIST.AUTOMATIC_SCORE'
      })
    }
  }

  $scope.handleBriefingSegmentationPricing = function () {
    if (!$scope.companyFeatures.briefingSegmentation) {
      api._openUpgradeCompanyPlanDialog({
        name: $translate.instant('billingFeatures.internalBriefings'),
        slug: 'WORKFLOW.SEGMENTED_BRIEFINGS'
      })
    }
  }

  $scope.handleBoardStepAdvancedResourcesPricing = function () {
    if (!$scope.companyFeatures.boardStepAdvancedResources.access) {
      api._openUpgradeCompanyPlanDialog({
        name: $scope.companyFeatures.boardStepAdvancedResources.data.featureName,
        slug: $scope.companyFeatures.boardStepAdvancedResources.data.featureSlug
      })
    }
  }

  function _openUpgradeCompanyPlanDialog (pricingData) {
    api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: {
          featureName: pricingData.name,
          featureSlug: pricingData.slug
        }
      })
      upgradeCompanyPlanDialog.open()
    })
  }

  function _handlePricingCheckboxes () {
    if (!$scope.companyFeatures.boardStepAdvancedResources.access) {
      $timeout(() => {
        $("input[name='linkToRequestDeliveryDate']").prop('checked', false)
      }, 500)
    }
  }

  $scope.changeDefaultRadioOptions = function (field) {
    const dropdownField = jQuery(`[data-field-value=${field.id}]`)
    $timeout(() => {
      dropdownField.dropdown('clear')

      if (field.defaultRadioOptions) {
        dropdownField.dropdown('set selected', [$translate.instant('yes'), $translate.instant('no')])
      }
    }, 0, false)

    field.hasConditional = false
    field.actions = []
  }

  $scope.handleCampaignChange = (campaign) => {
    $scope.briefing.groups = []
    $scope.briefing.users = []
    $scope.briefing.isPrivate = false

    $('.briefing-groups-dropdown').dropdown('clear')

    $scope.disablePublicationConfigs = !!campaign
    api._fillInputsWithCampaignInfo(campaign)
  }

  function _initializeMultiSelectFields (field) {
    if (!field?.type || !['RADIO', 'DROPDOWN', 'CHECKBOX'].includes(field?.type) || field.wasInitialized) {
      return
    }

    const dropdownParams = {
      allowAdditions: true,
      onAdd: function (value, text) {
        const selectedFieldId = jQuery(this).attr('data-field-value')
        const multiSelectField = BriefingService.findFieldByFieldId(selectedFieldId, $scope.briefing.sections)

        if (!multiSelectField) return
        if (!multiSelectField.fieldsOriginal) multiSelectField.fieldsOriginal = []

        let oldOptionField = multiSelectField.fieldsOriginal.find(({ id, title }) => value.toString() === id.toString() || value === title)

        if (!$scope.initialLoad) {
          const id = oldOptionField && oldOptionField.id ? oldOptionField.id : undefined

          const existingOption = multiSelectField.fields.find(option =>
            option.title === text && option.parentId === multiSelectField.id
          )

          if (!existingOption) {
            multiSelectField.fields.push({
              id: id === undefined ? nanoid() : id,
              briefingId: $scope.briefing.id,
              description: null,
              mandatory: false,
              parentId: multiSelectField.id || null,
              order: null,
              rules: [],
              title: text,
              type: 'OPTION',
              score: oldOptionField ? oldOptionField.score : 0,
              workingDaysValue: null
            })
          }
        }

        if (!oldOptionField) {
          oldOptionField = multiSelectField.fields.find(({ id, title }) => parseInt(value) === id || value === title)
        }

        if (multiSelectField.type === 'CHECKBOX' ||
              (oldOptionField && oldOptionField.score === 100)) {
          jQuery(this).find(`.label[data-value="${value}"]`).addClass('correct')
        }

        $scope.$broadcast('conditional.updateOptions', field.id)
      },
      onRemove: function (value) {
        if (addingNewField) return

        const selectedFieldId = jQuery(this).attr('data-field-value')
        const multiSelectField = BriefingService.findFieldByFieldId(selectedFieldId, $scope.briefing.sections)
        if (!multiSelectField) return

        const optionIndex = multiSelectField.fields.findIndex(({ id, title }) => parseInt(value) === id || value === title)
        multiSelectField.fields.splice(optionIndex, 1)

        ConditionalService.removeOptionFromConditional(multiSelectField, value)
        $scope.$broadcast('conditional.updateOptions', field.id)
      },
      onLabelSelect: function (selectedLabel) {
        const selectedLabelValue = jQuery(selectedLabel).attr('data-value')

        const selectedFieldId = jQuery(selectedLabel).parent('.fields-type-dropdown-options').attr('data-field-value')
        const multiSelectField = BriefingService.findFieldByFieldId(selectedFieldId, $scope.briefing.sections)
        if (!multiSelectField) return

        const optionIndex = multiSelectField.fields.findIndex(({ id, title }) => parseInt(selectedLabelValue) === id || selectedLabelValue === title.toString() || selectedLabel.text === id || selectedLabel.text === title.toString())

        if (multiSelectField.type === 'CHECKBOX') {
          jQuery(selectedLabel).addClass('correct') // checkbox values always green
        } else if (!jQuery(selectedLabel).hasClass('correct')) {
          jQuery(selectedLabel).addClass('correct')
          multiSelectField.fields[optionIndex].score = 100
        } else {
          jQuery(selectedLabel).removeClass('correct')
          multiSelectField.fields[optionIndex].score = 0
        }
        jQuery(selectedLabel).removeClass('active')
      }
    }

    if (field.type === 'RADIO') {
      dropdownParams.maxSelections = 8
      dropdownParams.message = {
        maxSelections: $translate.instant('invalidRadioOptionsNumber')
      }
    } else {
      delete dropdownParams.message
      delete dropdownParams.maxSelections
      jQuery(`.fields-type-dropdown-options[data-field-value=${field.id}] .message`).remove()
    }

    jQuery(`.fields-type-dropdown-options[data-field-value=${field.id}]`).dropdown(dropdownParams)
    field.wasInitialized = true
  }

  function _handleBriefingSegmentation (briefingSegmentation) {
    let pricingValue = false

    if (!briefingSegmentation) {
      pricingValue = true
    }

    $scope.toggleOptions = [
      { label: $translate.instant('users'), value: 'USERS', pricing: false },
      {
        label: $translate.instant('groups'),
        value: 'GROUPS',
        pricing: pricingValue,
        pricingData: {
          name: $translate.instant('billingFeatures.briefingSegmentation'),
          slug: 'WORKFLOW.SEGMENTED_BRIEFINGS'
        }
      }
    ]
  }

  $scope.onLastBriefingField = () => {
    $timeout(() => {
      jQuery('.fields-type-dropdown').dropdown()
      api._debouncedDropdownReload()

      jQuery('.dropdown-field-list').dropdown()
      // Creation event of business data relation field
      jQuery('.businessdatafield-dropdown').dropdown({
        onChange: function (value, text, $choice) {
          var target = jQuery($choice).closest('.ui.dropdown')
          if (value) {
            target.find('.dropdown.icon').removeClass('dropdown').addClass('delete').on('click', function () {
              target.dropdown('clear')
              $(this).removeClass('delete').addClass('dropdown')
            })
          }
        },
        placeholder: $translate.instant('select')
      })
      // Initial actvation of business data relation field
      jQuery('.businessdatafield-dropdown').each(function () {
        const dropdown = jQuery(this)
        if (jQuery(this).find('select').val()) {
          dropdown.find('.dropdown.icon').removeClass('dropdown').addClass('delete').on('click', function () {
            dropdown.dropdown('clear')
            jQuery(this).removeClass('delete').addClass('dropdown')
          })
        }
      })

      jQueryReadiness.dropdowns = true
      api._checkJQueryReadiness()
    }, 200)

    api._initializeSortableOrdenation()
  }

  $scope.addNewField = (section) => {
    addingNewField = true
    $timeout(() => {
      $('.input-data-field').popup({})
      addingNewField = false
    }, 1500, false)

    let lastSection = null
    if (!section) {
      lastSection = $scope.briefing.sections[$scope.briefing.sections.length - 1]
    }

    const newField = {
      id: nanoid(),
      briefingId: $scope.briefing.id,
      description: null,
      mandatory: false,
      defaultRadioOptions: false,
      fieldAssets: [],
      fields: [],
      order: section ? section.fields.length + 1 : lastSection.fields.length + 1,
      rules: [],
      title: '',
      type: '',
      score: 0,
      workingDaysValue: null
    }

    if (section) {
      section.fields.push(newField)
    } else if (lastSection) {
      lastSection.fields.push(newField)
    }

    flags.wasUpdated = true
  }

  $scope.removeField = function (field, index, section) {
    const fieldHasType = !!field.type

    if ($scope.isThereBriefingTasks && fieldHasType) {
      MessageService.warning({
        title: $translate.instant('warning'),
        text: $translate.instant('archiveFieldConfirm'),
        cancelButton: $translate.instant('no'),
        confirmButton: $translate.instant('yes'),
        closeOnConfirm: true,
        press: function () {
          section.fields[index].isArchived = true
          deletingField = true
          BriefingService.reorderFieldsAfterRemove(section.fields, index)
          api._debouncedDropdownReload()
          $timeout(() => {
            deletingField = false
          }, 1000)
        }
      })
    } else {
      MessageService.warning({
        title: $translate.instant('warning'),
        text: $translate.instant('deleteFieldConfirm'),
        cancelButton: $translate.instant('no'),
        confirmButton: $translate.instant('yes'),
        closeOnConfirm: true,
        press: function () {
          section.fields.splice(index, 1)
          deletingField = true
          BriefingService.reorderFieldsAfterRemove(section.fields, index)
          api._debouncedDropdownReload()
          $timeout(() => {
            deletingField = false
          }, 1000)
        }
      })
    }

    flags.wasUpdated = true
  }

  $scope.duplicateField = function (field, index, section) {
    const newField = Object.assign({}, field)
    newField.id = nanoid()
    newField.createdAt = undefined
    newField.updatedAt = undefined
    newField.score = 0
    newField.fields = []
    newField.$$hashKey = undefined
    newField.actions = []
    newField.rules = []
    newField.wasInitialized = false
    duplicatingField = true
    newField.duplicated = true
    newField.actionsActivated = false

    if (field.type === 'TEXT' && $scope.type === 'WORKFLOW') {
      newField.linkToRequestTitle = false
      newField.disableLinkToRequestTitleBtn = field.linkToRequestTitle
    }

    if (field.type === 'DATE' && $scope.type === 'WORKFLOW') {
      newField.linkToRequestDeliveryDate = false
      newField.disableLinkToRequestDeliveryDateBtn = field.linkToRequestDeliveryDate

      $timeout(() => {
        $('.input-data-field').popup({})
      }, 1500, false)
    }

    section.fields.splice(index + 1, 0, newField)
    BriefingService.reorderFieldsAfterDuplicate(section.fields, index + 1)

    if (newField.type === 'DROPDOWN' || newField.type === 'RADIO' || newField.type === 'CHECKBOX') {
      api._duplicateDropdownOptions(index, section, newField)
    }

    $timeout(() => {
      jQuery(`#dropdown-${newField.id}`).dropdown()
    }, 100, false)

    flags.wasUpdated = true

    $timeout(() => {
      duplicatingField = false
    }, 1000)
  }

  $scope.getBriefingFieldName = function (type) {
    return $translate.instant(`briefingFields.${type}.title`)
  }

  $scope.getBriefingFieldIcon = function (type) {
    return $translate.instant(`briefingFields.${type}.icon`)
  }

  $scope.getMultipleOptionsValues = function (options) {
    return options.map(option => option.id).join(',')
  }

  $scope.chooseFieldMandatoryAssets = function (field) {
    field.mandatoryAssets = !field.acceptAnswerAssets
  }

  $scope.selectType = function (field, type) {
    const regExp = /[a-z]/i
    const isNewField = regExp.test(field.id.toString())
    if ($scope.type === 'WORKFLOW' && $scope.isThereBriefingTasks && !isNewField) {
      $timeout(() => {
        $(`#dropdown-${field.id}`).dropdown('set selected', field.type)
      }, 500, false)

      MessageService.error({
        title: 'oopsTitle',
        text: 'changeFieldTypeError',
        confirmButtonText: 'ok'
      })

      return
    }

    field.type = type
    field.defaultRadioOptions = false

    if (['DROPDOWN', 'RADIO', 'CHECKBOX'].includes(type)) {
      api._initializeMultiSelectFields(field)
    }

    if (field.type !== 'DROPDOWN' && field.type !== 'RADIO' && field.type !== 'CHECKBOX' && field.type !== 'NUMBER' && field.type !== 'DATE' && field.type !== 'SIGNATURE') {
      field.hasCommentField = false
    }

    if (type !== 'DROPDOWN' && type !== 'RADIO' && type !== 'CHECKBOX') {
      field.score = 0
      api._calculateBriefingScore()
    }

    if (field.type === 'SIGNATURE') {
      field.acceptAnswerAssets = false
      field.mandatoryAssets = true
    } else if (field.type === 'DATE' && $scope.type === 'WORKFLOW') {
      field.linkToRequestDeliveryDate = false
      $scope.updateUniqueBtnsByFieldType(field.type, 'linkToRequestDeliveryDate', 'disableLinkToRequestDeliveryDateBtn')
    } else if (field.type === 'TEXT' && $scope.type === 'WORKFLOW') {
      field.linkToRequestTitle = false
      $scope.updateUniqueBtnsByFieldType(field.type, 'linkToRequestTitle', 'disableLinkToRequestTitleBtn')
    }

    field.hasConditional = false
    field.actions = null

    flags.wasUpdated = true
  }

  $scope.updateUniqueBtnsByFieldType = function (fieldType, propertyName, disabledPropertyName) {
    if ($scope.type !== 'WORKFLOW') {
      return
    }

    const filteredFields = BriefingService.filterFields($scope.briefing, (field) => field.type === fieldType)
    const selectedFieldIndex = filteredFields.findIndex(field => field[propertyName])
    let disabled = true

    if (selectedFieldIndex === -1) {
      disabled = false
    }

    filteredFields.forEach((field, index) => {
      if (index !== selectedFieldIndex) {
        field[disabledPropertyName] = disabled
      }
    })
  }

  $scope.handleAllUsersChange = function () {
    $scope.allUsersChecked = !$scope.allUsersChecked
    flags.wasUpdated = true
  }

  $scope.handleDataBusinessChange = (field) => {
    field.businessDataField = api._avaliableBusinessDataField(field)
      .find(option => option.id === Number(field.businessDataFieldId))
  }

  $scope.updateOrCreateBriefing = function (briefing) {
    $scope.loading = true

    if (!$scope.selectedCampaign || ($scope.selectedCampaign.id !== briefing.campaignId)) {
      briefing.campaignId = $scope.selectedCampaign?.id || null
    }

    const _briefing = Object.assign({}, briefing)
    const dropdownTypes = ['DROPDOWN', 'RADIO', 'CHECKBOX']
    let scoredFieldsError = []
    showInvalidFields = true

    const conditionalFieldsInvalid = api._validateConditionalFields(_briefing)
    if (conditionalFieldsInvalid) {
      ConfirmationModalService.createModal({
        description: $translate.instant('conditionalFieldsInvalidWarning'),
        buttonConfirmText: $translate.instant('gotIt'),
        hideCancelButton: true
      })

      $scope.loading = false
      return
    }

    const isThereEmptySections = _briefing.sections.some(section => !section.fields.length)

    if (isThereEmptySections) {
      ToastService.showErrorToast($translate.instant('emptySectionError'))
      $scope.loading = false
      return
    }

    const dropdowns = BriefingService.filterFields(_briefing, (field) => dropdownTypes.includes(field.type))
    const carrosselFields = BriefingService.filterFields(_briefing, (field) => field.type === 'CARROSSEL')
    const radioFields = BriefingService.filterFields(_briefing, (field) => field.type === 'RADIO')
    const checkboxFields = BriefingService.filterFields(_briefing, (field) => field.type === 'CHECKBOX')
    const invalidImgNumber = carrosselFields.some(carrosselField => carrosselField.fieldAssets.length <= 1)
    const invalidRadioOptionsNumber = radioFields.some(radioFields => radioFields.fields.length > 8)
    const isThereEmptyDropdowns = dropdowns.some(dropdown => !dropdown.fields.length && !dropdown.isArchived)
    const isThereFieldsWithoutType = BriefingService.someFields(_briefing, (field) => !field.type)

    const isThereInconsistentActions = ConditionalService.validateInconsistentConditionals(_briefing, $scope.type)
    api._validateIsArchivedAttr(_briefing)

    // fix option order
    dropdowns.forEach((field) => {
      if (field.fields && field.fields.length > 1) {
        for (var index = 0; index < field.fields.length; index++) {
          field.fields[index].order = index + 1
        }
      }
    })

    // make checkbox score
    checkboxFields.forEach(field => {
      const lenght = field.fields.length
      const fieldScore = Math.round(10000 / lenght) / 100 // // delaing with decimals
      let index = 1
      let totalScore = 0
      field.fields.forEach(fieldValue => {
        if (index !== lenght) {
          fieldValue.score = fieldScore
          totalScore += fieldScore
          index += 1
        } else {
          fieldValue.score = Math.round((100 - totalScore) * 100) / 100
        }
      })
    })

    if (_briefing.briefingType === 'WORKFLOW') {
      _briefing.users = api._getUserValues()
      _briefing.groups = api._getGroupValues()
    } else {
      api._calculateBriefingScore()
    }

    _briefing.assignees = _briefing.assignees.map(user => user.id)

    if (_briefing.automaticScore) {
      const filterFunction = function (field) {
        if (!field.score > 0) return false
        const scoredValues = field.fields.filter(value => value.score > 0)
        return scoredValues.length === 0
      }

      scoredFieldsError = BriefingService.filterFields(_briefing, filterFunction)
    }

    BriefingService.sanitazeBriefingForm(_briefing)

    if (_briefing.automaticScore && _briefing.totalScore !== 100) {
      MessageService.error({
        title: $translate.instant('oopsTitle'),
        text: $translate.instant('ScoreNeedToBeFilled'),
        confirmButtonText: 'ok',
        press: uncriticalError()
      })
    } else if (_briefing.automaticScore && scoredFieldsError.length > 0) {
      MessageService.error({
        title: $translate.instant('oopsTitle'),
        text: $translate.instant('noCorrectAnswerForFields'),
        confirmButtonText: 'ok',
        press: uncriticalError()
      })
    } else if (isThereFieldsWithoutType) {
      MessageService.error({
        title: $translate.instant('oopsTitle'),
        text: $translate.instant('fieldsWithoutType'),
        confirmButtonText: 'ok',
        press: uncriticalError()
      })
    } else if (isThereEmptyDropdowns) {
      MessageService.error({
        title: $translate.instant('oopsTitle'),
        text: $translate.instant('dropdownWithNoOptions'),
        confirmButtonText: 'ok',
        press: uncriticalError()
      })
    } else if (invalidImgNumber) {
      MessageService.error({
        title: 'oopsTitle',
        text: 'invalidImgNumber',
        confirmButtonText: 'ok',
        press: uncriticalError()
      })
    } else if (invalidRadioOptionsNumber) {
      MessageService.error({
        title: 'oopsTitle',
        text: 'invalidRadioOptionsNumber',
        confirmButtonText: 'ok',
        press: uncriticalError()
      })
    } else if (isThereInconsistentActions) {
      MessageService.error({
        title: 'warning',
        text: 'conditional.inconsistentActionError',
        confirmButtonText: 'ok',
        press: uncriticalError()
      })
    } else if (_briefing.id) {
      BriefingService.updateBriefing(_briefing.id, _briefing).then(() => {
        $timeout(() => {
          $scope.loading = false
          ToastService.defaultSuccessToast()
          flags.wasSaved = true
        }, 500)

        const conditionalCount = ConditionalService.getConditionalActionsCount(_briefing)

        const types = {
          AUDIT: 'Audit',
          WORKFLOW: 'Request'
        }

        SegmentService.track('update-form', { name: _briefing.name, condition_questions: conditionalCount, type: types[_briefing.briefingType] })
        activate()
        $scope.backToBriefings()
      }).catch(() => {
        $scope.loading = false
        ToastService.defaultErrorToast()
      })
    } else {
      BriefingService.createBriefing(_briefing).then(() => {
        $scope.loading = false
        flags.wasSaved = true
        MessageService.success({
          title: $translate.instant('successTitle'),
          confirmButtonText: $translate.instant('ok'),
          press: function () {
            $scope.backToBriefings()
          }
        })

        const conditionalCount = ConditionalService.getConditionalActionsCount(_briefing)
        const types = {
          AUDIT: 'Audit',
          WORKFLOW: 'Request'
        }

        SegmentService.track('created-form', { name: _briefing.name, condition_questions: conditionalCount, campaign_id: _briefing.campaignId, type: types[_briefing.briefingType] })
        if ($scope.selectedCampaign.id) {
          SegmentService.track('created-checklist', { campaign_id: $scope.selectedCampaign.id })
        }
      }).catch((e) => {
        $scope.loading = false
        if (e.status === 422 && e.data?.reason?.includes('expired')) {
          ToastService.showErrorToast($translate.instant('campaignErrors.expiredCampaign'))
        } else {
          ToastService.defaultErrorToast()
        }
      })
    }
  }

  $scope.avaliableBusinessDataField = api._avaliableBusinessDataField

  function _avaliableBusinessDataField (field) {
    const invalidFields = ['DROPDOWN', 'RADIO', 'IMAGE']
    let condition = () => false
    switch (field.type) {
      case 'TEXT':
        condition = bdf => !invalidFields.includes(bdf.type)
        break

      case 'RICH_TEXT':
        condition = bdf => !invalidFields.includes(bdf.type)
        break

      case 'NUMBER':
        condition = bdf => bdf.type === 'NUMBER'
        break

      case 'DROPDOWN':
        condition = bdf => bdf.type === 'DROPDOWN'
        break

      case 'RADIO':
        condition = bdf => bdf.type === 'RADIO'
        break
    }

    let isAvaliable = []
    if ($scope.bdfTypes) {
      isAvaliable = $scope.bdfTypes.filter(condition)
    }

    return isAvaliable
  }

  $scope.handleGoBackButton = () => {
    if (flags.wasUpdated && !flags.wasSaved) {
      return api._openWarningSaveDiscardDialog()
    }

    $scope.backToBriefings()
  }

  $scope.backToBriefings = function () {
    if ($stateParams.origin === 'CAMPAIGNS') {
      return $state.go('campaigns-edit', { id: $state.params.campaignId, activeTab: 'tab-6' })
    }

    if ($scope.type === 'WORKFLOW') {
      $state.go('workflow.briefings')
    } else if ($scope.type === 'AUDIT') {
      $state.go('audit.models')
    }
  }

  $scope.newBriefing = function () {
    if ($stateParams.origin === 'CAMPAIGNS') {
      return $state.go('campaigns-edit', { id: $state.params.campaignId, activeTab: 'tab-6' })
    }

    if ($scope.type === 'WORKFLOW') {
      $state.go('admin.workflowBriefingNew')
    } else if ($scope.type === 'AUDIT') {
      $state.go('admin.auditBriefingNew')
    }
  }

  $scope.handleRichTextFieldBlur = function (e, editor) {
    TrixEditorService.handleRichTextFieldBlur(e, editor, jQuery(document.activeElement))
  }

  $scope.handleRichTextFieldFocus = function (e, editor) {
    TrixEditorService.handleRichTextFieldFocus(e, editor)
  }

  $scope.disattach = function (oRemoveAttachment) {
    let attachmentField
    const carrosselFields = BriefingService.filterFields($scope.briefing, (field) => field.type === 'CARROSSEL')
    carrosselFields.forEach(carrosselField => {
      const attachment = carrosselField.fieldAssets.find(fieldAsset => fieldAsset.id === oRemoveAttachment)
      if (attachment) {
        attachmentField = carrosselField
      }
    })
    AttachmentService.disattach(oRemoveAttachment, attachmentField.fieldAssets, $scope.attachments, null, null)
    attachmentField.fieldAssets = attachmentField.fieldAssets.filter((file) => {
      return file.id !== oRemoveAttachment
    })

    ConditionalService.removeOptionFromConditional(attachmentField, oRemoveAttachment)
    $scope.$broadcast('conditional.updateOptions', attachmentField.id)
  }

  $scope.openAttachAssetsDialog = (field) => {
    getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
      const attachInsideTheModuleModal = UdsModalService.createModal({
        controller: AttachInsideTheModuleModalController,
        modalName: 'attachInsideTheModuleModal',
        data: {
          selectedTab: 'recents',
          allowedAssetExtensionsSelection: ['png', 'jpeg', 'jpg']
        },
        onClose: async (assetsToAttach) => {
          if (!assetsToAttach?.length) {
            return
          }
          $scope.attachedAllFiles = false
          $scope.attachments = [...field.fieldAssets]

          for await (const asset of assetsToAttach) {
            const attachment = await NewAssetService.getAssetDetails(asset.id)

            $scope.uploadedFiles.push(attachment)
            field.fieldAssets.push(attachment)
          }

          $timeout(() => {
            $scope.attachedAllFiles = true
            $scope.$broadcast('conditional.updateOptions', field.id)
          }, 1000)
        }
      })

      attachInsideTheModuleModal.open()
    })
  }

  $scope.attach = function (files, field) {
    $scope.attachedAllFiles = false
    $scope.attachments = [...field.fieldAssets]

    UploadService.uploadMultipleFileToS3(files).then((uploadedFiles) => {
      const assets = uploadedFiles

      $timeout(() => {
        assets.forEach((asset) => {
          const uploadedFile = asset.files[0]
          const attachment = {
            ...uploadedFile,
            ...asset,
            generatingThumb: true
          }

          $scope.uploadedFiles.push(attachment)
          field.fieldAssets.push(attachment)
        })

        api._onCompleteCarrosselUpload()
      })
    }).catch(error => {
      if (BackendErrorParserService.isInvalidFileError(error)) {
        ToastService.showErrorToast($translate.instant('fileExtensionNotAllowed'))
      }
    })
  }

  $scope.downloadAttachment = function (attachment) {
    const attachmentUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [attachment.id])
    try {
      AttachmentService.downloadAttachment(attachment, attachmentUrl)
    } catch (error) {
      ToastService.defaultErrorToast()
    }
  }

  $scope.attActions = {
    delete: $scope.disattach.bind($scope),
    download: $scope.downloadAttachment.bind($scope)
  }

  $scope.sumToFieldScore = function (field) {
    if ($scope.briefing.totalScore < $scope.maxScore) {
      if ($scope.maxScore - $scope.briefing.totalScore > 5) {
        field.score += 5
      } else {
        field.score += $scope.maxScore - $scope.briefing.totalScore
      }
      field.score = Math.round(field.score * 100) / 100 // problemas com o ponto flutuante
      api._calculateBriefingScore()
    }
  }

  $scope.subtractOfFieldScore = function (field) {
    if (field.score > 0) {
      field.score -= 5
      field.score = Math.round(field.score * 100) / 100 // problemas com o ponto flutuante
      if (field.score < 0) { field.score = 0 }

      api._calculateBriefingScore()
    }
  }

  $scope.validateScoreInput = function (field) {
    field.score = field.score || 0
    api._calculateBriefingScore()
    field.score = Math.round(parseFloat(field.score) * 100) / 100 // problemas com o ponto flutuante

    if ($scope.briefing.totalScore > $scope.maxScore) {
      field.score = $scope.maxScore - $scope.briefing.totalScore + field.score
      field.score = Math.round(field.score * 100) / 100 // problemas com o ponto flutuante
    }
    if (field.score < 0) field.score = 0
    api._calculateBriefingScore()
  }

  $scope.unfilledField = field => {
    const fields = field.fields

    return !fields.length && !field.defaultRadioOptions && showInvalidFields
  }

  $scope.createGroupClick = function () {
    api.getNewGroupDialogController().then(({ NewGroupDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: NewGroupDialogController,
        modalName: 'newGroupDialog',
        onClose: (bEmailSuccessfullySent) => {
          if (bEmailSuccessfullySent) {
            MessageService.success({
              title: $translate.instant('successTitle'),
              confirmButton: $translate.instant('ok')
            })
          }
        }
      })
      modal.open()
    })
  }

  $scope.toggleConditional = (field) => {
    if (field.hasConditional) {
      field.actions = []
    } else {
      field.actions = [ConditionalService.createNewConditionalAction()]
      field.actionsActivated = true
      field.carrosselMultiselect = false
    }
  }

  $scope.getSectionTagLabel = (index, sectionCount) => {
    const text1 = $translate.instant('section')
    const text2 = $translate.instant('of')
    return `${text1} ${++index} ${text2} ${sectionCount}`
  }

  $scope.deleteBriefingSection = (index) => {
    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('deleteSectionConfirm'),
      cancelButton: $translate.instant('no'),
      confirmButton: $translate.instant('yes'),
      closeOnConfirm: true,
      press: function () {
        $timeout(() => {
          $scope.briefing.sections.splice(index, 1)
          $scope.$broadcast('conditional.updateTypes')
          flags.wasUpdated = true
        })
      }
    })
  }

  $scope.addNewSection = () => {
    $scope.briefing.sections.push({ id: nanoid(), fields: [] })
    $scope.$broadcast('conditional.updateTypes')
    api._initializeSortableOrdenation()

    flags.wasUpdated = true
  }

  $scope.isSaveButtonDisabled = () => {
    const isWorkflowAndBoardNameIsEmpty = $scope.briefing.board?.name === '' && $scope.type === 'WORKFLOW'
    let hasFields = false

    if ($scope.briefing.sections) {
      hasFields = $scope.briefing.sections.some(section => section.fields.length)
    }

    return isWorkflowAndBoardNameIsEmpty || !$scope.briefing.name || !hasFields || !$scope.attachedAllFiles || !$scope.jQueryComponentsReady
  }

  $scope.onFieldClick = (fieldId) => {
    const fieldContainer = $(`.details-content .briefing-fields-list .briefing-field#${fieldId}`)
    if (!fieldContainer) return

    if (fieldContainer.hasClass('minimized')) {
      api._minimizeAllFields()

      $timeout(() => {
        fieldContainer.removeClass('minimized')
      }, 100, false)
    }
  }

  $scope.planHasBusinessData = () => {
    return !planName.includes('Workflow')
  }

  $scope.getCurrentCampaignId = () => {
    return $scope.briefing?.isActiveInCampaign === false ? null : $scope.currentCampaignId
  }

  function _reloadDropdownFields () {
    $timeout(() => {
      // Reinit field type dropdown
      jQuery('.fields-type-dropdown').dropdown()
      jQuery('.dropdown-field-list').dropdown()

      jQuery('.fields-type-dropdown-options').each(function () {
        const selectedFieldId = jQuery(this).attr('data-field-value')
        const briefingField = BriefingService.findFieldByFieldId(selectedFieldId, $scope.briefing.sections)
        if (!briefingField) return

        if (briefingField.duplicated && duplicatingField) return

        const oldValues = [...briefingField.fields] || [...briefingField.fieldsOriginal]

        briefingField.wasInitialized = false
        api._initializeMultiSelectFields(briefingField)

        if (!sortingField && !deletingField && !duplicatingField) {
          jQuery(this).dropdown('clear')
          briefingField.fields = []
        }

        if (briefingField.duplicated && !briefingField.actionsActivated) {
          briefingField.actions = []
          briefingField.hasConditional = false
        }

        briefingField.fieldsOriginal = oldValues.map(option => option)

        const values = oldValues.map(field => {
          if (field.id) {
            return {
              value: field.id,
              name: field.title,
              text: field.title
            }
          }
        }).filter(field => field !== undefined)
        let selectedValues = oldValues.map(field => field.id ? `${field.id}` : field.title)
        selectedValues = api._removeDuplicatedValues(selectedValues)

        const numberRegex = /^\d+$/
        const number = selectedValues.filter(value => numberRegex.test(value))
        const string = selectedValues.filter(value => !numberRegex.test(value))

        if (!deletingField && !duplicatingField) {
          $timeout(() => {
            jQuery(this).dropdown('setup menu', { values })
            jQuery(this).dropdown('set selected', number)
            jQuery(this).dropdown('set selected', string)
          }, 100, false)
        }
      })
      $scope.initialLoad = false
    }, 100)
  }

  function _forceRestoreDropdownOptions (field) {
    if (!field) {
      return
    }

    $timeout(() => {
      if (field.type) {
        const fieldTypeDropdown = jQuery(`#dropdown-${field.id}`)
        if (fieldTypeDropdown.length && fieldTypeDropdown.hasClass('dropdown')) {
          fieldTypeDropdown.dropdown('set selected', field.type)
        }
      }

      if (field.fields && field.fields.length && ['DROPDOWN', 'RADIO', 'CHECKBOX'].includes(field.type)) {
        const dropdownElement = jQuery(`.fields-type-dropdown-options[data-field-value="${field.id}"]`)
        if (dropdownElement.length) {
          const values = field.fields.map(option => ({
            value: option.id,
            name: option.title,
            text: option.title
          }))

          const selectedValues = field.fields.map(option => option.id ? `${option.id}` : option.title)
          const uniqueSelectedValues = [...new Set(selectedValues)] // Remove duplicates
          const numberRegex = /^\d+$/
          const numberValues = uniqueSelectedValues.filter(value => numberRegex.test(value))
          const stringValues = uniqueSelectedValues.filter(value => !numberRegex.test(value))

          if (!dropdownElement.hasClass('dropdown')) {
            api._initializeMultiSelectFields(field)
          }

          $timeout(() => {
            dropdownElement.dropdown('setup menu', { values })
            if (numberValues.length > 0) {
              dropdownElement.dropdown('set selected', numberValues)
            }
            if (stringValues.length > 0) {
              dropdownElement.dropdown('set selected', stringValues)
            }
          }, 100, false)
        }
      }
    }, 100, false)
  }

  function _reattachFieldClickHandlers (destinationSectionId) {
    const destinationSection = $scope.briefing.sections.find(section => section.id.toString() === destinationSectionId.toString())
    if (!destinationSection) return

    destinationSection.fields.forEach(field => {
      const fieldElement = document.getElementById(field.id)

      if (fieldElement) {
        $(fieldElement).off('click.fieldExpand')

        $(fieldElement).on('click.fieldExpand', () => {
          $scope.onFieldClick(field.id)
        })
      }
    })
  }

  function uncriticalError () {
    $scope.loading = false
  }

  function _getBriefingModel (id) {
    if (id) {
      BriefingService.getCompanyBriefing(id).then(briefing => {
        if (!briefing) {
          $scope.briefingNotFound = true
        }
        $scope.briefing = briefing || $scope.briefing

        $scope.disablePublicationConfigs = !!$scope.briefing.campaignId && $scope.briefing.isActiveInCampaign !== false

        if ($scope.type === 'AUDIT') {
          api._calculateBriefingScore()
        }

        if (Array.isArray($scope.briefing.board) && !$scope.briefing.board.length) {
          $scope.selectedBoard = undefined
          $scope.briefing.board = {
            id: ''
          }
        } else if ($scope.briefing.board) {
          $scope.selectedBoard = $scope.briefing.board.id
        }

        $scope.briefing.groups = $scope.briefing.groups.map(function (group) {
          return group.id.toString()
        })

        if ($scope.briefing.groups.length || $scope.briefing.users.length) {
          $scope.allUsersChecked = false
        }

        if ($scope.briefing.groups.length) {
          $scope.segmentationOption = 'GROUPS'
        }

        if ($scope.type === 'WORKFLOW') {
          ConditionalService.setConditionals($scope.briefing)
        }

        if (briefing.campaignId) {
          $scope.currentCampaignId = briefing.campaignId
        }

        api._addDropdownValue($scope.briefing.groups)
        api._setWorkingDaysValue($scope.briefing)
        $scope.loading = false

        $timeout(() => {
          $('.input-data-field').popup({})
        }, 1500, false)
      }).then(() => {
        BriefingService.isThereBriefingTasks(id).then(result => {
          $scope.isThereBriefingTasks = result
        })

        if ($scope.type === 'WORKFLOW') {
          api._checkBriefingActiveTasks(id)
        }
      })
    } else {
      $timeout(() => {
        $scope.loading = false
      }, 0, true)
    }
  }

  function _setWorkingDaysValue (briefing) {
    function setWorkingDaysValue (field) {
      if (field.type === 'DATE' && field.rules.length) {
        field.workingDaysValue = parseInt(field.rules[0].value)
        field.workingDaysCheck = true
      }
    }

    briefing.sections.forEach(section => {
      section.fields.forEach(setWorkingDaysValue)
    })
  }

  function _getFieldsTypes (briefingType) {
    return BriefingService.getFieldsTypes().then(types => {
      $scope.fieldTypes = types ? types.filter(type => type !== 'OPTION' && type !== 'MULTISELECT' && (((briefingType !== 'AUDIT' && type !== 'SIGNATURE') || ['TEXT', 'NUMBER', 'DATE', 'DROPDOWN', 'RADIO', 'CHECKBOX', 'RICH_TEXT'].includes(type)) || (briefingType === 'AUDIT' && type === 'SIGNATURE'))) : null
    })
  }

  function _getBusinessDataFields () {
    return BusinessDataService.getCompanyBusinessDataService().then(data => {
      $scope.bdfTypes = data
      $scope.businesDataOptions = api._avaliableBusinessDataField({ type: 'TEXT' })
        .map(option => {
          return {
            label: option.title,
            value: option.id
          }
        })
    })
  }

  function _getCompanyBoards () {
    return BoardsService.getBoards().then(data => {
      $timeout(() => {
        $scope.boards = data.rows.map(board => ({ label: board.name, value: board.id }))
      }, 50)
    })
  }

  function _calculateBriefingScore () {
    if ($scope.type === 'WORKFLOW') return
    $scope.briefing.totalScore = $scope.briefing.sections[0].fields.reduce((acc, field) => {
      // problemas com ponto flutuante
      acc += Math.round(parseFloat(field.score) * 100) / 100
      acc = Math.round(parseFloat(acc) * 100) / 100
      return acc
    }, 0)
    $scope.briefing.leftScore = $scope.maxScore - $scope.briefing.totalScore
    $scope.briefing.leftScore = Math.round(parseFloat($scope.briefing.leftScore) * 100) / 100
    $scope.briefing.leftScoreMsg = $translate.instant('ScoreToBeFilled', { leftScore: $scope.briefing.leftScore })
  }

  function _duplicateDropdownOptions (index, section, newField) {
    const originalField = section.fields[index]
    const hasConditional = !!originalField.actions?.length
    const actions = hasConditional ? JSON.parse(JSON.stringify(originalField.actions)) : []

    const newOptions = originalField.fields.map(field => {
      const newObj = {
        ...field,
        id: nanoid(),
        parentId: newField.id
      }

      actions.forEach(action => {
        action.options.forEach(option => {
          if (option.id === field.id) {
            option.id = newObj.id
          }
        })
      })

      return newObj
    })

    const selectedValues = originalField.fields.map(field => field.title.toString())
    const newFieldId = section.fields[index + 1].id

    newField.fields = newOptions
    newField.actions = actions

    $timeout(() => {
      jQuery(`[data-field-value=${newFieldId}]`).dropdown({
        allowAdditions: true
      })
      jQuery(`[data-field-value=${newFieldId}]`).dropdown('set selected', selectedValues)
    }, 500, false)

    section.fields.forEach((field, idx) => {
      field.index = idx
      field.id = field.id || nanoid()
    })
  }

  function _getUsers () {
    return AdminService.getUsers(usersTop, usersTop * usersIndex, { role: ['DESIGNER', 'USER'] }).then(api._handleSuccessGetUsers)
  }

  function _getGroups () {
    return GroupService.getGroups(null, null, null, true).then(api._handleGetGroupsResponse)
  }

  function _handleSuccessGetUsers (res) {
    const response = res.d.results
    $scope.aUsers.push(...response.filter(user => user.id !== $rootScope.oUser.id))

    if (res.d.__count > $scope.aUsers.length) {
      usersIndex++
      api._getUsers()
    }
  }

  function _handleGetGroupsResponse (oRes) {
    $scope.aGroups = oRes.d.results

    $('.briefing-groups-dropdown').dropdown({
      showOnFocus: false,
      onChange: function () {
        if (!$scope.$$phase) {
          $scope.$apply()
        }
      }
    })
  }

  function _getGroupValues () {
    const aGroups = $('.briefing-groups-dropdown').dropdown('get values') || []

    if ($scope.allUsersChecked) {
      return []
    }

    return aGroups.map(function (sGroupId) {
      return parseInt(sGroupId)
    })
  }

  function _getUserValues () {
    if ($scope.allUsersChecked) {
      return []
    }
    return $scope.briefing.users.map(function (oUser) {
      return oUser.id
    })
  }

  function _addDropdownValue (groups) {
    $timeout(() => {
      $('.briefing-groups-dropdown')
        .dropdown('set selected', groups)
    }, 100, false)
  }

  function _onCompleteCarrosselUpload () {
    $scope.attachedAllFiles = true
  }

  function _validateIsArchivedAttr (briefing) {
    function validateIsArchivedAttr (field) {
      if (field.isArchived === null) {
        field.isArchived = false
      }
    }

    briefing.sections.forEach(section => {
      section.fields.forEach(validateIsArchivedAttr)
    })
  }

  function _setDefaultBriefing () {
    $scope.briefing = {
      id: null,
      assignees: [],
      briefingType: $scope.type,
      name: '',
      description: '',
      automaticScore: false,
      totalScore: 0,
      leftScore: 100,
      leftScoreMsg: $translate.instant('ScoreToBeFilled', { leftScore: 100 }),
      sections: [{
        id: nanoid(), fields: []
      }],
      isPrivate: false,
      users: [],
      groups: []
    }
  }

  function _validateConditionalFields (briefing) {
    if ($scope.type === 'AUDIT') return false

    $scope.$broadcast('conditional.validateFields')

    return ConditionalService.validateConditionalFields(briefing)
  }

  function _minimizeAllFields (event) {
    const exceptionClasses = ['exception-minimize', 'label', 'delete', 'addition', 'search']

    if (event) {
      const classList = Array.from(event.target.classList)
      const isException = classList.some(item => exceptionClasses.includes(item))
      if (isException) return
    }

    $('.details-content .briefing-fields-list .briefing-field').addClass('minimized')
  }

  function _initializeSortableOrdenation () {
    getSortable().then(({ Sortable }) => {
      if ($scope.type === 'AUDIT') {
        api._initializeSortableFields(Sortable, `briefing-fields-list-${$scope.briefing.sections[0].id}`, $scope.briefing.sections[0])
      } else {
        $scope.briefing.sections.forEach(section => {
          api._initializeSortableFields(Sortable, `briefing-fields-list-${section.id}`, section)
        })
      }

      $timeout(() => {
        jQueryReadiness.sortables = true
        api._checkJQueryReadiness()
      }, 1000, false)
    })
  }

  function _initializeSortableFields (Sortable, elementId, section) {
    if (section.sortableObj) return

    $timeout(() => {
      const sortableList = document.getElementById(elementId)
      if (sortableList) {
        section.sortableObj = Sortable.create(sortableList, {
          group: 'section',
          sort: true,
          animation: 550,
          onEnd: api._onFieldSort,
          axis: 'y',
          handle: '.sort-icon-handle'
        })
      }
    }, 1000, false)
  }

  function _onFieldSort (event) {
    const originSectionId = event.from.id.replace('briefing-fields-list-', '')
    const destinationSectionId = event.to.id.replace('briefing-fields-list-', '')
    const fieldId = event.item.id
    const field = BriefingService.findFieldByFieldId(fieldId, $scope.briefing.sections)

    api._handleFieldOrder(field, event.newIndex + 1, originSectionId, destinationSectionId)
    api._verifyInconsistentAction(field, originSectionId, destinationSectionId)
    $scope.$broadcast('conditional.updateTypes')
  }

  function _handleFieldOrder (field, newIndex, originSectionId, destinationSectionId) {
    if (!field) return

    sortingField = true
    if ($scope.type === 'WORKFLOW') {
      if (originSectionId === destinationSectionId) {
        const section = $scope.briefing.sections.find(item => item.id.toString() === destinationSectionId.toString())
        api._orderFieldOnSameSection(field, newIndex, section)
      } else {
        api._orderFieldDifferentSection(field, newIndex, originSectionId, destinationSectionId)
      }
    } else {
      api._orderFieldOnSameSection(field, newIndex, $scope.briefing.sections[0])
    }

    $timeout(() => {
      api._forceRestoreDropdownOptions(field)

      $timeout(() => {
        api._reattachFieldClickHandlers(destinationSectionId)
      }, 200)
    }, 1000)
  }

  function _orderFieldOnSameSection (field, newIndex, section) {
    const oldIndex = field.order
    if (oldIndex === newIndex) return
    field.order = newIndex

    section.fields.forEach(item => {
      if (newIndex < oldIndex) {
        if (item.order >= newIndex && item.order < oldIndex && item.id !== field.id) {
          item.order++
        }
      } else if (newIndex > oldIndex) {
        if (item.order <= newIndex && item.order > oldIndex && item.id !== field.id) {
          item.order--
        }
      }
    })

    flags.wasUpdated = true
  }

  function _orderFieldDifferentSection (field, newIndex, originSectionId, destinationSectionId) {
    const oldIndex = field.order
    const originSection = $scope.briefing.sections.find(item => item.id.toString() === originSectionId.toString())
    const index = originSection.fields.findIndex(item => item.id === field.id)

    if (index !== -1) {
      originSection.fields.splice(index, 1)
    }

    originSection.fields.forEach(item => {
      if (item.order > oldIndex) {
        item.order--
      }
    })

    const destinationSection = $scope.briefing.sections.find(item => item.id.toString() === destinationSectionId.toString())
    field.order = newIndex
    destinationSection.fields.splice(newIndex - 1, 0, field)

    destinationSection.fields.forEach(item => {
      if (item.order >= newIndex && item.id !== field.id) {
        item.order++
      }
    })

    flags.wasUpdated = true
  }

  function _verifyInconsistentAction (field, originSectionId, destinationSectionId) {
    if (originSectionId !== destinationSectionId) {
      if (!field || !field.actions?.length) return
      field.actions.forEach(action => {
        const hasSameSectionId = action.sectionId?.toString() === destinationSectionId.toString()

        if (hasSameSectionId) {
          $timeout(() => {
            $(`.conditional-container .conditional-rule .types-${action.id}`).attr('negative', true)
            field.inconsistentAction = true
          })
        }
      })
    }
  }

  function _removeDuplicatedValues (values) {
    return values.filter((item, index) => {
      return values.indexOf(item) === index
    })
  }

  function _fillInputsWithCampaignInfo (campaign) {
    if (!campaign) return

    $scope.allUsersChecked = !campaign.info.groups.length
    $scope.segmentationOption = 'GROUPS'
    $scope.briefing.groups = campaign.info.groups.map(group => group.id.toString())
    $('.briefing-groups-dropdown').dropdown('set selected', $scope.briefing.groups)
  }

  $scope.handleLocalSearch = (searchTerm) => {
    UserService.getAdministratorsAndDesigners({ search: searchTerm }).then(response => { $scope.users = response.rows })
  }

  function _checkBriefingActiveTasks (briefingId) {
    BriefingService.isThereBriefingTasks(briefingId).then(result => {
      if (result) {
        $scope.hasActiveTasksFromUsers = !$scope.briefing.isPrivate
      } else {
        $scope.hasActiveTasksFromUsers = false
      }
    }).catch(() => {
      $scope.hasActiveTasksFromUsers = false
    })
  }
}

export { BriefingDetailsController }
